module.exports = __webpack_public_path__ + "static/oic_video-7cf9074e3b88c064803f42d674748148.mp4";